// initial state
export default {
	persistedData: {
		employeeDiscountToken: null,
		retroactivePointsAssignmentPendingOrderId: null,
		orderEditMode: false,
		customerEvaluationData: null,
		targetGroupData: null,
		orderEditType: null,
		orderEditOriginalOrder: null,
		newCartData: {
			customerDetails:{},
			cartOrderId: null,
			specialNotes: "",
			userConsent: false,
			productSelections: [],
			checkoutStep: 0,
			checkoutStepGt3: 0,
			cartUserDataSubmitted: false,
			cartSmsVerified: false,
			shopData: {
				submitted: false
			},
			pickupDate: null,
			pickupTime: null,
			pickupData: {
				submitted: false
			},
			orderSent: false,
			orderIsPrepaid: false,
			lastOrderNumber: false,
			lastOrderPrice: 0,
			lastOrderPriceWithReturnableItems: 0,
			lastOrderProductIds : [],
			lastOrderReceiptLines: [],
			productCategory: [],
			isOrderChanged: false,
			pixelPurchaseFired: false,
			mustBeHeated: false,
			asapPickup: false,
			tenantSpecificData: {},
			vouchersRedeemed: [],
			groupOrderId: "",
			isUserGroupOrderOwner: "",
			groupOrderFriendsOrderData: [],
			qrCodeTableServingData: {
				tableNumber: undefined,
				isQrCodeTableServing: undefined
			},
			voucherVirtualOrderId: null
		},
		editModeData: {
			cartOrderId: null,
			checkoutStep: 0,
			checkoutStepGt3: 0,
			specialNotes: "",
			cartUserDataSubmitted: false,
			productSelections: [],
			shopData: {
				submitted: false
			},
			pickupDate: null,
			pickupTime: null,
			pickupData: {
				submitted: false
			},
			orderIsPrepaid: false,
			lastOrderNumber: 0,
			lastOrderPrice: 0,
			lastOrderPriceWithReturnableItems: 0,
			lastOrderProductIds : [],
			lastOrderReceiptLines: [],
			productCategory: [],
			isOrderChanged: false,
			pixelPurchaseFired: false,
			mustBeHeated: false,
			asapPickup: false,
			tenantSpecificData: {},
			voucherVirtualOrderId: null
		},
		discount: {
			promoCode: ""
		},
		deliveryDetails: null,
		temporaryDeliveryAddress: null,
		lastUpdateTime: undefined,
		sunsetPoints: null,
		friendInviteCode: undefined,
		isReorder: false,
		originalProductSelectionsFromPreviousOrder: [],
		originalPreviousOrderTotal: 0,
		shouldShowMysteryBox: true,
		recommendedProductsCatalogPage: [],
		voucherReward: null,
		selectedDealId: null,
		menuProductIdsForReselection: [],
		unavailableProductIds: [],
		singleMainProductIdsToMenuIdsMap: null,
		upgradeToMenuFromBasketFlag: false,
		productSelectionIdToRemove: [],
		customerTrackingTagData: null
	},
	cachedShops: [],
	cachedPickupRules: [],
	isUpsellModalOpened: false,
	showEmployeeDiscountSuccessMessage: false,
	recommendedProducts: [],
	pickedRecommendedProducts: [],
	experimentId: null,
	estimatedPoints: 0,
	currentCatalogPageExtId: null,
	currentProductId: null,
	discountCapped: null,
	marketingCardDataOnClick: {
		category: null,
		upgradeToMenuDialog: false,
		productId: null
	},
	rcmMarketingCard: {
		productIds: [],
		enable: false
	},
	lastProductSelectionForAddDipsDialog: null
};
